export const UNITS = ['kg', 'g', 'lb', 'L', 'ml', 'count', 'piece']

export function dimensionOf(unit) {
  if (unit === 'kg' || unit === 'g' || unit === 'lb') return 'weight'
  if (unit === 'L' || unit === 'ml') return 'volume'
  return 'count'
}

export function getCompatibleUnits(ingredientUnit) {
  const weight = ['kg', 'g', 'lb']
  const volume = ['L', 'ml']
  const count = ['count']

  if (weight.includes(ingredientUnit)) return weight
  if (volume.includes(ingredientUnit)) return volume
  if (count.includes(ingredientUnit)) return count
  return [ingredientUnit]
}

export function toBase(quantity, unit) {
  const d = dimensionOf(unit)
  if (d === 'weight') {
    if (unit === 'kg') return { base: quantity, dimension: 'weight' }
    if (unit === 'lb') return { base: quantity * 0.45359237, dimension: 'weight' }
    return { base: quantity / 1000, dimension: 'weight' }
  }
  if (d === 'volume') {
    if (unit === 'L') return { base: quantity, dimension: 'volume' }
    return { base: quantity / 1000, dimension: 'volume' }
  }
  return { base: quantity, dimension: 'count' }
}

export function lineCostPreview(quantity, lineUnit, ingredientPricePerUnit, ingredientUnit) {
  const a = dimensionOf(lineUnit)
  const b = dimensionOf(ingredientUnit)
  if (a !== b) return { cost: 0, error: 'Unit mismatch' }
  const lineBase = toBase(quantity, lineUnit).base
  const ingBase = toBase(1, ingredientUnit).base
  if (ingBase === 0) return { cost: 0, error: 'Invalid' }
  const pricePerBase = ingredientPricePerUnit / ingBase
  return { cost: lineBase * pricePerBase }
}

export function displayMultiplier(unit) {
  return unit === 'g' || unit === 'ml' ? 100 : 1
}

export function displayUnit(unit) {
  if (unit === 'g') return '100g'
  if (unit === 'ml') return '100ml'
  return unit
}

export function displayPrice(pricePerUnit, unit) {
  return pricePerUnit * displayMultiplier(unit)
}

export function defaultPerAmount(unit) {
  return unit === 'g' || unit === 'ml' ? 100 : 1
}

export function toStoredPrice(enteredPrice, perAmount) {
  if (!perAmount || perAmount <= 0) return enteredPrice
  return enteredPrice / perAmount
}

export function groupByCategory(items) {
  const map = new Map()
  for (const item of items) {
    const cat = (item.category || '').trim()
    if (!map.has(cat)) map.set(cat, [])
    map.get(cat).push(item)
  }
  return [...map.entries()].sort(([a], [b]) => {
    if (!a && b) return 1
    if (a && !b) return -1
    return a.localeCompare(b, undefined, { sensitivity: 'base' })
  })
}

export const cad = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' })
export function money(n) {
  if (typeof n !== 'number' || Number.isNaN(n)) return '—'
  return cad.format(n)
}